// extracted by mini-css-extract-plugin
export default {"homeVideoContent":"logo_animation_homeVideoContent__zaHHu","coinBlastReward":"logo_animation_coinBlastReward__tjiDQ"};